import React from "react";
import "./Signup.css";
import FadeIn from "react-fade-in";
import LoadAnim from "../App/LoadAnim.js";

export class ReadOnlySeatmap extends React.Component {
  _mounted = false;
  constructor(props) {
    super(props);

    this.getSeatData = this.getSeatData.bind(this);

    this.updateSeats = this.updateSeats.bind(this);
    this.isReservedByMe = this.isReservedByMe.bind(this);
    this.checkIfAllSeatsTaken = this.checkIfAllSeatsTaken.bind(this);

    //We fill state from backend
    this.state = {
      rows: [],

      selectedSeats: [],
      selectedSeatObjs: [],

      timeStamp: 0,
      timeToStop: 0,
      timeLeft: 0,
      skipRequest: false,

      locked: false
    };
  }


  async componentDidMount() {
    this._mounted = true;
    await this.getSeatData();
    let availableSeats = await this.checkIfAllSeatsTaken();
    if (availableSeats === 0) {
      await this.props.seatsFull();
    }
    await this.checkIfAllSeatsTaken();
    this.interval = setInterval(() => this.updateSeats(), 6000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this._mounted = false;
  }

  //We refresh the seat-data every X seconds.
  async updateSeats() {
    if (this.state.skipRequest === false) {
      this.getSeatData();
    }
    this.forceUpdate();
    this.checkIfAllSeatsTaken();
  }

  checkIfAllSeatsTaken() {
    let availableSeats = 0;
    for (let i = 0; i < this.state.rows.length; i++) {
      if (this.state.rows[i].isReserved !== "yes") {
        availableSeats++;
      }
    }

    return availableSeats;
  }

  //We grab the seat JSON from backend
  async getSeatData() {
    this.setState({ skipRequest: true });
    //If tab is not visible, we just stop it
    if (this.props.visibility === false) {
      console.log("Tab not in focus");
      this.setState({ skipRequest: false });
      return;
    }

    if (this._mounted === true) {
      let myHeaders = new Headers();
      myHeaders.append("pragma", "no-cache");
      myHeaders.append("cache-control", "no-cache");

      let myInit = {
        method: "GET",
        headers: myHeaders
      };

      await fetch("/api/seating/getseats", myInit)
        .then(response => {
          return response.json();
        })
        .then(rowdata => {
          this.setState({ rows: rowdata });
          this.setState({ skipRequest: false });
        })
        .catch(error => {
          console.error("Error:", error);
          setTimeout(() => {
            this.getSeatData();
          }, 10000);
        });
    }
  }

  //We check if the user has reserved to set custom color
  isReservedByMe(seat) {
    let seatIdentity = "s" + seat.number + "r" + seat.rownum;
    let exists = this.state.selectedSeats.indexOf(seatIdentity);

    if (exists !== -1) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    let rows = this.state.rows;

    // Group seats by row number
    const rowsData = {};
    for (let i = 0; i < rows.length; i++) {
      const rowNum = rows[i].rownum;
      if (!rowsData[rowNum]) {
        rowsData[rowNum] = [];
      }
      rowsData[rowNum].push(rows[i]);
    }

    // Define which rows should have dividers after them
    const dividersAfter = [2, 4, 6, 8];

    let seatList = [];

    if (this.state.selectedSeats.length > 0) {
      for (let i = 0; i < this.state.selectedSeats.length; i++) {
        let row = this.state.selectedSeats[i].substring(
          this.state.selectedSeats[i].lastIndexOf("r") + 1
        );

        let seat = this.state.selectedSeats[i].substring(
          this.state.selectedSeats[i].lastIndexOf("s") + 1,
          this.state.selectedSeats[i].lastIndexOf("r")
        );

        seatList.push(
          <div key={seat + row}>
            Rad: {row} Plass: {seat}{" "}
          </div>
        );
      }
    }

    return (
      <div>
        {(this.state.rows === undefined ||
          this.state.rows === null ||
          this.state.rows.length === 0) && (
          <div className="customLoadPosition">
            <LoadAnim />{" "}
          </div>
        )}
        {this.state.rows !== undefined &&
          this.state.rows !== null &&
          this.state.rows.length !== 0 && (
            <FadeIn>
              <div
                className={
                  "col-centered seatContainer staticmap " +
                  (this.props.signupOver ? "staticmapOpacity" : "")
                }
              >
                {this.props.signupOver === false && (
                  <div>
                    {" "}
                    <h5>Start påmelding for å velge plass </h5>
                  </div>
                )}
                {this.props.signupOver && (
                  <div>
                    {" "}
                    <h5>Påmelding er stengt</h5>
                  </div>
                )}

                <p />

                {Object.keys(rowsData).length > 0 && Object.keys(rowsData).sort((a, b) => parseInt(a, 10) - parseInt(b, 10)).map((rowNum, index, sortedRows) => {
                  const rowSeats = rowsData[rowNum];
                  if (rowSeats.length === 0) return null; // Skip empty rows

                  const previousRowNum = index > 0 ? parseInt(sortedRows[index - 1], 10) : 0;
                  const needsDivider = dividersAfter.includes(previousRowNum);

                  return (
                    <React.Fragment key={rowNum}>
                      {needsDivider && <div className="rowDivider"> </div>}
                      <div className="row seatRow">
                        <h4 className="rowNum">{rowNum}</h4>
                        {rowSeats.map((seat, seatIndex) => (
                          <div
                            key={seatIndex}
                            title={
                              (seat.isBlocked ? "Blokkert" : "") ||
                              (seat.isReserved.match("no") ? "Ledig" : "") ||
                              (seat.isReserved.match("yes") ? "Reservert" : "") ||
                              (seat.isReserved.match("held") ? "Holdes av" : "")
                            }
                            className={
                              "btn disabled seatBox " +
                              ((seat.isBlocked ? "blocked-seat" : "") ||
                                (seat.isReserved.match("no") ? "btn-info open" : "") ||
                                (seat.isReserved.match("yes") ? "taken" : "") ||
                                (this.isReservedByMe(seat) ? "mySeat" : "") ||
                                (seat.isReserved.match("held") ? "held" : ""))
                            }
                            onClick={!this.props.signupOver && !this.props.signupFull && !seat.isBlocked ? this.props.onSeatmapClick : undefined}
                          >
                            {seat.number}
                          </div>
                        ))}
                        <h4 className="rowNum">{rowNum}</h4>
                      </div>
                    </React.Fragment>
                  );
                })}

              </div>
            </FadeIn>
          )}
      </div>
    );
  }
}

export default ReadOnlySeatmap;



// WEBPACK FOOTER //
// ./src/Components/Signup/ReadOnlySeatmap.js